"use client";

import { cn } from "@workspace/frontend-ui";
import BannerNavigationItem from "./BannerNavigationItem";

export type BannerNavItem = {
  id: string;
  name: string;
  imgSrc: string;
};

type Props = {
  items: BannerNavItem[];
  selected: number;
  delay: number;
  onItemSelect: (index: number) => void;
};

const BannerNavigation: FC<Props> = ({
  items,
  selected,
  delay,
  onItemSelect,
}) => (
  <div
    className={cn(
      "ml-0 hidden max-w-none grid-flow-col auto-rows-min grid-cols-4 overflow-hidden rounded-b-xl bg-card",
      "lg:grid 3xl:-ml-3! 3xl:grid-flow-row! 3xl:grid-cols-none! 3xl:pl-3 3xl:pt-1 3xl:max-w-[268px]!",
      items.length === 5 && "grid-cols-5",
      "ltr:3xl:rounded-r-xl rtl:3xl:rounded-r-none rtl:3xl:rounded-l-xl",
    )}
  >
    {items.map((item, index) => (
      <BannerNavigationItem
        key={item.id}
        item={item}
        isActive={index === selected}
        isLast={index === items.length - 1}
        delay={delay}
        onSelect={() => onItemSelect(index)}
      />
    ))}
  </div>
);

export default BannerNavigation;
